import React, { useEffect, useState } from "react";
import Select from "react-select";
import { axiosMaster } from "../api/axiosInstance";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const SysNewUserRegister = () => {

  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");

  /* ================= STATE ================= */

  const [userOptions, setUserOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [restaurantOptions, setRestaurantOptions] = useState([]);
  const [userTypeOptions, setUserTypeOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);

  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);

  const [mobileNo, setMobileNo] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [mobileError, setMobileError] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= MOBILE VALIDATION ================= */

  const handleMobileChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");

    if (value.length > 10) value = value.slice(0, 10);

    setMobileNo(value);

    if (value.length > 0 && value.length < 10) {
      setMobileError("Mobile number must be 10 digits");
    } else {
      setMobileError("");
    }
  };

  /* ================= LOAD USERS ================= */

  useEffect(() => {
    fetchUsers();
    fetchGroups();
  }, []);

  const fetchUsers = async () => {
    try {

      const res = await axiosMaster.get("/UserMaster");

      const opts = (res.data || []).map((u) => ({
        value: u.user_Id,
        label: u.user_Name,
        groupId: u.groupId,
        restId: u.restId
      }));

      setUserOptions(opts);

    } catch (err) {
      console.error("User load error", err);
    }
  };

  /* ================= LOAD GROUPS ================= */

  const fetchGroups = async () => {
    try {

      const res = await axiosMaster.get("/GroupMaster");

      const opts = (res.data || []).map((g) => ({
        value: g.groupId,
        label: g.groupName
      }));

      setGroupOptions(opts);

    } catch (err) {
      console.error("Group load error", err);
    }
  };

  /* ================= USER SELECT ================= */

  const handleUserChange = async (option) => {

    setSelectedUser(option);
    setSelectedGroup(null);
    setSelectedRestaurant(null);
    setUserTypeOptions([]);
    setRoleOptions([]);

    if (!option) return;

    try {

      const group = groupOptions.find(
        (g) => g.value === option.groupId
      );

      if (group) setSelectedGroup(group);

      const res = await axiosMaster.get(
        `/RestaurantMaster/GetByGroup?groupId=${option.groupId}`
      );

      const restaurants = (res.data || []).map((r) => ({
        value: r.restId,
        label: r.restaurantName
      }));

      setRestaurantOptions(restaurants);

      const rest = restaurants.find(
        (r) => r.value === option.restId
      );

      if (rest) setSelectedRestaurant(rest);

      /* load user types */

      const userTypeRes = await axiosMaster.get("/UserTypeMaster");

      setUserTypeOptions(
        (userTypeRes.data || []).map((u) => ({
          value: u.userTypeId,
          label: u.userTypeName
        }))
      );

    } catch (err) {
      console.error(err);
    }
  };

  /* ================= USER TYPE CHANGE ================= */

  const handleUserTypeChange = async (option) => {

    setSelectedUserType(option);
    setSelectedRole(null);

    if (!option) return;

    try {

      const res = await axiosMaster.get(
        `/RoleMaster/GetByUserType?userTypeId=${option.value}`
      );

      setRoleOptions(
        (res.data || []).map((r) => ({
          value: r.roleId,
          label: r.roleName
        }))
      );

    } catch (err) {
      console.error("Role load error", err);
    }
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async () => {

    if (loading) return;

    if (mobileNo.length !== 10) {
      setMobileError("Mobile number must be 10 digits");
      return;
    }

    if (!password) return alert("Enter password");
    if (!selectedUser) return alert("Select user");
    if (!selectedUserType) return alert("Select user type");
    if (!selectedRole) return alert("Select role");

    try {

      setLoading(true);

      const payload = {

        user_Id: selectedUser.value,
        User_Name: selectedUser.label,

        mobileNo,
        passwordHash: password,

        groupId: selectedGroup?.value,
        groupName: selectedGroup?.label,

        restId: selectedRestaurant?.value,
        restaurantName: selectedRestaurant?.label,

        userTypeId: selectedUserType.value,
        userTypeName: selectedUserType.label,

        roleId: selectedRole.value,
        roleName: selectedRole.label,

        createdBy: storedUser?.userId || 0,

        fcmToken: "Sau",
        refreshJwtToken: ""
      };

      await axiosMaster.post("/Auth/register", payload);

      alert("User registered successfully");

      setSelectedUser(null);
      setSelectedGroup(null);
      setSelectedRestaurant(null);
      setSelectedUserType(null);
      setSelectedRole(null);

      setMobileNo("");
      setPassword("");

    } catch (err) {

      console.error("Register error", err);
      alert("Error registering user");

    } finally {

      setLoading(false);

    }
  };

  /* ================= UI ================= */

  return (
    <div className="bg-white rounded-xl shadow-lg p-5 max-w-3xl mx-auto">

      <h2 className="text-xl font-bold mb-4">
        New User Registration
      </h2>

      <div className="grid md:grid-cols-2 gap-4">

        <Select
          options={userOptions}
          value={selectedUser}
          onChange={handleUserChange}
          placeholder="Select User"
        />

        <input
          type="text"
          placeholder="Mobile number"
          value={mobileNo}
          onChange={handleMobileChange}
          className={`border p-2 rounded-lg ${
            mobileError ? "border-red-500" : ""
          }`}
        />

        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border p-2 rounded-lg w-full pr-10"
          />

          <button
            type="button"
            onClick={() => setShowPassword((s) => !s)}
            className="absolute right-3 top-3 text-gray-500"
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        <Select
          options={groupOptions}
          value={selectedGroup}
          isDisabled
          placeholder="Group"
        />

        <Select
          options={restaurantOptions}
          value={selectedRestaurant}
          isDisabled
          placeholder="Restaurant"
        />

        <Select
          options={userTypeOptions}
          value={selectedUserType}
          onChange={handleUserTypeChange}
          placeholder="Select user type"
        />

        <Select
          options={roleOptions}
          value={selectedRole}
          onChange={setSelectedRole}
          placeholder="Select role"
        />

      </div>

      <div className="flex justify-end mt-5">

        <button
          onClick={handleSubmit}
          disabled={loading}
          className={`px-5 py-2 rounded-lg text-white ${
            loading ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {loading ? "Registering..." : "Register User"}
        </button>

      </div>

    </div>
  );
};

export default SysNewUserRegister;